import React from "react";

export function LandingPageFaqDropdownValues(customerData) {
    return [

        {
            idx: '1',
            title: 'Are prequalification results guaranteed?',
            content:
                'No. Prequalification results are not a guarantee that you will qualify for ' +
                'Ford Credit financing or for particular terms. After selecting a vehicle and ' +
                'finalizing your credit application through the dealership, Ford Credit will review ' +
                'your creditworthiness.',
            border: true
        },
        {
            idx: '2',
            title: 'Can I get prequalified more than once?',
            content: 'Yes. Results are valid for 180 days. You may get prequalified again after that time.',
            border: true
        },
        {
            idx: '3',
            title: 'What if prequalification doesn’t return an amount?',
            content: 'If we cannot return an amount, you are welcome to try again in 30 days. In the meantime, if you have ' +
                'additional questions about financing options, please contact a salesperson at a Ford dealership.',
            border: true
        },
        {
            idx: '4',
            title: 'Why doesn’t prequalification affect my credit score?',
            content:
                'Because you’re not applying for credit, it will not affect your credit score. Instead, prequalification ' +
                'requires you to report your income and personal information, and then a soft credit inquiry is made.',
            border: true
        },
        {
            idx: '5',
            title: 'What happens after I get prequalified?',
            content: 'We’ll help you search for the right vehicle online or at a local dealership.',
            border: true
        },
        {
            idx: '6',
            title: 'Will my prequalification details be shared with local dealerships?',
            content: 'During prequalification, you can decide if you’d like to share your results with local dealerships.',
            border: true
        },
        {
            idx: '7',
            title: 'What are my financing options?',
            content: (
                <span>
          We offer several options for leasing or financing your next Ford vehicle. Explore and compare all our{' '}
                    <a target='_blank'
                       href={customerData.countryCode.value === 'CAN' ? 'https://www.ford.ca/finance/finance-options' : 'https://www.ford.com/finance/finance-options'}
                       rel='noreferrer'>
            Financing Options
          </a>{' '}
                    to find the right one for you.
        </span>
            ),
            border: false
        }
    ];
}
